import { filterActivitiesSinceLastTouch } from "@/lib/utils";
import { ActivityModel } from "@/models/pipeline";
import moment from "moment";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

type ActivityHoverProps = {
  activities: ActivityModel[];
  lastTouch?: string | null;
  children: React.ReactNode;
};

const formatActivityTime = (activityTime: string): string => {
  const activityMoment = moment(activityTime);
  const now = moment();

  if (activityMoment.isSame(now, "day")) {
    return `Today, ${activityMoment.format("HH:mm")}`;
  } else if (activityMoment.isSame(now.clone().subtract(1, "day"), "day")) {
    return `Yesterday, ${activityMoment.format("HH:mm")}`;
  } else {
    return activityMoment.format("DD/MM/YY, HH:mm");
  }
};

export const ActivityHover = ({ activities, lastTouch, children }: ActivityHoverProps) => {
  const filteredActivities = filterActivitiesSinceLastTouch(activities || [], lastTouch);

  return filteredActivities && filteredActivities.length > 0 ? (
    <Tooltip>
      <TooltipTrigger asChild>
        <div
          className={`text-center ${
            filteredActivities && filteredActivities.length > 0
              ? "cursor-default truncate underline decoration-slate-400 decoration-dotted underline-offset-4"
              : ""
          }`}
        >
          {children}
        </div>
      </TooltipTrigger>
      <TooltipContent>
        {filteredActivities.map((activity, index) => (
          <div key={index} className="flex items-center justify-between gap-3">
            <span className="font-medium">{activity.activityTypeName}</span>
            <span className="font-normal">{formatActivityTime(activity.activityTime)}</span>
          </div>
        ))}
      </TooltipContent>
    </Tooltip>
  ) : (
    "-"
  );
};
